<template>
  <svg  class="draw-flow" :class="{'dark':skinType}" viewBox="0 0 1000 450">
    <defs>
      <marker
        id="arrow1"
        viewBox="0 0 6 6"
        refX="5"
        refY="3"
        markerUnits="strokeWidth"
        markerWidth="6"
        markerHeight="6"
        orient="auto"
      >
        <path d="M 0 0 L 6 3 L 0 6 z" fill="gray" stroke-width="0"></path>
      </marker>
      <marker
        id="arrow2"
        viewBox="0 0 6 6"
        refX="5"
        refY="3"
        markerUnits="strokeWidth"
        markerWidth="6"
        markerHeight="6"
        orient="auto"
      >
        <path d="M 0 0 L 6 3 L 0 6 z" fill="#ff3300" stroke-width="0"></path>
      </marker>
      <marker
        id="arrow3"
        viewBox="0 0 6 6"
        refX="5"
        refY="3"
        markerUnits="strokeWidth"
        markerWidth="6"
        markerHeight="6"
        orient="auto"
      >
        <path d="M 0 0 L 6 3 L 0 6 z" fill="#225ee1" stroke-width="0"></path>
      </marker>
    </defs>
    <g
      id="6d6cfa2b-e8a7-3b2d-916f-18d619d9b2e2"
      from="91,152"
      to="179,151.5"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 91 152 L 179 151.5"
        pointer-events="stroke"
      ></path>
      <path
        d="M 91 152 L 179 151.5"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="gray"
        marker-end="url(#arrow1)"
      ></path>
      <text text-anchor="middle" x="135" y="146.75" style="cursor: text"></text>
    </g>
    <g
      id="72ac60d3-2978-bbf8-c220-e63ff8f98b9c"
      from="329,151.5"
      to="420,153.5"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 329 151.5 L 420 153.5"
        pointer-events="stroke"
      ></path>
      <path
        d="M 329 151.5 L 420 153.5"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="gray"
        marker-end="url(#arrow1)"
      ></path>
      <text
        text-anchor="middle"
        x="374.5"
        y="147.5"
        style="cursor: text"
      ></text>
    </g>
    <g
      id="1c2f5037-dea0-2059-bc2e-94f432f778d0"
      from="570,153.5"
      to="660,153.5"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 570 153.5 L 660 153.5"
        pointer-events="stroke"
      ></path>
      <path
        d="M 570 153.5 L 660 153.5"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="gray"
        marker-end="url(#arrow1)"
      ></path>
      <text text-anchor="middle" x="615" y="148.5" style="cursor: text"></text>
    </g>
    <g
      id="73b9b3cb-3089-5135-98dc-eb84b3a80740"
      from="810,153.5"
      to="254,321"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 810 153.5 L 810 269.25 L 254 269.25 L 254 321"
        pointer-events="stroke"
      ></path>
      <path
        d="M 810 153.5 L 810 269.25 L 254 269.25 L 254 321"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="gray"
        marker-end="url(#arrow1)"
      ></path>
      <text text-anchor="middle" x="532" y="264.25" style="cursor: text"></text>
    </g>
    <g
      id="a3577543-d55c-bcdd-703c-8ef81b701521"
      from="329,353.5"
      to="421,353.5"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 329 353.5 L 421 353.5"
        pointer-events="stroke"
      ></path>
      <path
        d="M 329 353.5 L 421 353.5"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="gray"
        marker-end="url(#arrow1)"
      ></path>
      <text text-anchor="middle" x="375" y="348.5" style="cursor: text"></text>
    </g>
    <g
      id="f6451e6b-343e-5ef7-c4b3-5d101275a179"
      from="571,353.5"
      to="842,353"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 571 353.5 L 842 353"
        pointer-events="stroke"
      ></path>
      <path
        d="M 571 353.5 L 842 353"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="gray"
        marker-end="url(#arrow1)"
      ></path>
      <text
        text-anchor="middle"
        x="706.5"
        y="348.25"
        style="cursor: text"
      ></text>
    </g>
    <g
      id="3d9cb004-d781-5324-5b04-cf9a1c7cdd77"
      from="254,119"
      to="868,327"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 254 119 L 254 79 L 868 79 L 868 327"
        pointer-events="stroke"
      ></path>
      <path
        d="M 254 119 L 254 79 L 868 79 L 868 327"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="#ff3300"
        marker-end="url(#arrow2)"
      ></path>
      <text text-anchor="middle" x="561" y="74"
      :fill="skinType?'white':'black'" style="cursor: text">结束</text>
    </g>
    <g
      id="7bc62491-9d90-99c0-c899-b1be2a4b89c8"
      from="495,186"
      to="254,184"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 495 186 L 495 220 L 254 220 L 254 184"
        pointer-events="stroke"
      ></path>
      <path
        d="M 495 186 L 495 220 L 254 220 L 254 184"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="#ff3300"
        marker-end="url(#arrow2)"
      ></path>
      <text text-anchor="middle" x="374.5" y="215" style="cursor: text"
      :fill="skinType?'white':'black'">
        否
      </text>
    </g>
    <g
      id="edb6fc9b-a896-7753-35a0-9cd4b2ad0b37"
      from="735,186"
      to="254,184"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 735 186 L 735 240 L 254 240 L 254 184"
        pointer-events="stroke"
      ></path>
      <path
        d="M 735 186 L 735 240 L 254 240 L 254 184"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="#ff3300"
        marker-end="url(#arrow2)"
      ></path>
      <text text-anchor="middle" x="494.5" y="235" style="cursor: text"
      :fill="skinType?'white':'black'">
        否
      </text>
    </g>
    <g
      id="d3045d14-5f98-6620-209a-9caab09d733d"
      from="496,386"
      to="254,386"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 496 386 L 496 420 L 254 420 L 254 386"
        pointer-events="stroke"
      ></path>
      <path
        d="M 496 386 L 496 420 L 254 420 L 254 386"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="#ff3300"
        marker-end="url(#arrow2)"
      ></path>
      <text text-anchor="middle" x="375" y="415" style="cursor: text"
       :fill="skinType?'white':'black'">否</text>
    </g>
    <ProcessEnd :endInfo="{name:'开始',status:0}" transform="translate(30,127)"></ProcessEnd>
    <ProcessItem :processInfo="managedProcessList[0]" transform="translate(180,122)"></ProcessItem>
    <ProcessItem :processInfo="managedProcessList[1]" transform="translate(420,122)"></ProcessItem>
    <ProcessItem :processInfo="managedProcessList[2]" transform="translate(660,122)"></ProcessItem>
    <ProcessItem :processInfo="managedProcessList[3]" transform="translate(180,322)"></ProcessItem>
    <ProcessItem :processInfo="managedProcessList[4]" transform="translate(420,322)"></ProcessItem>
    <ProcessEnd :endInfo="{name:'结束',status:1}" transform="translate(840,327)"></ProcessEnd>
  </svg>
</template>
<script>
import ProcessItem from '@/components/equipment-operational/components/dialog/process-item.vue';
import ProcessEnd from '@/components/equipment-operational/components/dialog/process-end.vue';
import clone from '@/utils/clone';

export default {
  name: 'process-info',
  props: {
    selectProcessInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      processList: [{
        name: '工单派发',
        status: 0,
      }, {
        name: '到达现场',
        status: 0,
      }, {
        name: '故障确认',
        status: 0,
      }, {
        name: '抢修完成',
        status: 0,
      }, {
        name: '工单审核',
        status: 0,
      }],
    };
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
    managedProcessList() {
      const list = clone(this.processList);
      for (let i = 0; i < list.length; i += 1) {
        list[i].status = 2;
        if (list[i].name === (this.selectProcessInfo.F_TaskName ? this.selectProcessInfo.F_TaskName
          : this.selectProcessInfo.F_NodeName)) {
          list[i].status = 1;
          break;
        }
      }
      return list;
    },
  },
  components: {
    ProcessItem,
    ProcessEnd,
  },
};
</script>
<style scoped>
.draw-flow{
  width:100%;
  max-width: 100%;
}
</style>
